import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
import HomeMain from "./components/home/HomeMain";
import AdminPanel from "./components/AdminPanel";
import PostsMain from "./components/posts/PostsMain";
import Detail from "./components/posts/Detail";
import PostMain from "./components/cpanel/post/PostMain";
import UserMain from "./components/cpanel/user/UserMain";
import AboutUsMain from "./components/cpanel/about/AboutUsMain";
import AboutMain from "./components/about/AboutMain";
import Header from "./components/header/Header";
import SettingsMain from "./components/settings/settings";
import PageNotFound from "./components/PageNotFound"

import {
  getDaysInMonth, monthNames, daysName, getPostsByLanguage, languageConvertor
} from "./components/general_functions/general";

import { generalS } from "./strings/general";

import "./styles/css/main.css";
import { local } from "d3";

class Routes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      calender: [],
      latestProjects: [],
      lpObjs: {},
      latestEvents: [],
      teamMembers: {},
      aboutUs: [],
      posts: [],
      homeAlbum: [],
      allpost: [],
      addresses: [],
      workshopTraiing: [],
      ourMission: [],
      film: [],
      design: [],
      print: [],
      onlineTV: [],
      history: [],
      homeImageDivider: [],
      information: [],
      footerText: [],
      products: [],
    };
  }

  componentDidMount() {
    let { language } = this.props.context;
    let localLanguage = localStorage.getItem('language');
    if (localLanguage != null) {
      this.changeLanguageHandler(localLanguage)
    } else {
      this.changeLanguageHandler(language)
    }
  }

  changeLanguageHandler = (language) => {
    getPostsByLanguage(languageConvertor(language), res => {
      let { post } = res;
      let calender = [];
      let latestProjects = [];
      let latestEvents = [];
      let workshopTraiing = [];
      let ourMission = [];
      let film = [];
      let design = [];
      let print = [];
      let onlineTV = [];
      let teamMembers = [];
      let aboutUs = [];
      let homeAlbum = [];
      let history = [];
      let homeImageDivider = [];
      let addresses = [];
      let information = [];
      let footerText = [];
      let products = [];

      if (post) {
        for (let i = 0; i < post.length; i++) {
          switch (post[i].data.value.type) {
            case 'calender': calender.push(post[i]);
              break;
            case 'latestProject': latestProjects.push(post[i]);
              break;
            case 'upcomingEvents': latestEvents.push(post[i]);
              break;
            case 'workshopTraiing': workshopTraiing.push(post[i]);
              break;
            case 'ourmission': ourMission.push(post[i]);
              break;
            case 'film': film.push(post[i]);
              break;
            case 'design': design.push(post[i]);
              break;
            case 'print': print.push(post[i]);
              break;
            case 'onlineTV': onlineTV.push(post[i]);
              break;
            case 'history': history.push(post[i]);
              break;
            case 'teamMembers': teamMembers.push(post[i]);
              break;
            case 'aboutus': aboutUs.push(post[i]);
              break;
            case 'homeAlbum': homeAlbum.push(post[i]);
              break;
            case 'homeImageDivider': homeImageDivider.push(post[i]);
              break;
            case 'addresses': addresses.push(post[i]);
              break;
            case 'information': information.push(post[i]);
              break;
            case 'footerText': footerText.push(post[i]);
              break
            case 'products': products.push(post[i]);
              break
          }
        }

        let lpObjs = { col1: [], col2: [], col3: [] }
        let x = 0;
        for (let i = 0; i < products.length; i++) {
          x = i / 3;
          if (x.toFixed(2).toString().split(".")[1] == 0) {
            lpObjs.col1.push(products[i])
          } else if (x.toFixed(2).toString().split(".")[1] == 33) {
            lpObjs.col2.push(products[i])
          } else if (x.toFixed(2).toString().split(".")[1] == 67) {
            lpObjs.col3.push(products[i])
          }
        }

        let index = 0;
        let teamMembersObj = { col1: [], col2: [] }
        for (let i = 0; i < teamMembers.length; i++) {
          index = i / 3;
          if (index.toFixed(2).toString().split(".")[1] == 0) {
            teamMembersObj.col1.push(teamMembers[i]);
          } else {
            teamMembersObj.col2.push(teamMembers[i]);
          }
        }

        let postTemp = [];
        let postObj = {}
        for (let i = 0; i < post.length; i++) {
          postObj = post[i].data.value;
          postObj._id = post[i]._id;
          postObj.postId = post[i].postId;
          postObj.fileNames = post[i].fileNames
          postTemp.push(postObj)
        }

        this.setState({
          calender, latestProjects, lpObjs,
          latestEvents, teamMembers, teamMembersObj, aboutUs,
          ourMission, workshopTraiing, film, design, print, onlineTV, history,
          posts: postTemp, homeAlbum, homeImageDivider,
          allpost: post, addresses, information, footerText, products
        })
      }
    });
  }

  render() {
    let { context } = this.props;
    let { language, authenticated } = context;

    let localLanguage = localStorage.getItem('language');
    if (localLanguage != null) {
      language = localLanguage;
    }

    let { calender, latestProjects,
      lpObjs, latestEvents, workshopTraiing, teamMembersObj, teamMembers,
      aboutUs, posts, homeAlbum, ourMission,
      film, design, print, onlineTV, history, homeImageDivider,
      allpost, addresses, information, footerText, products } = this.state;
    return (
      <div className={language == 2 ? 'ltr' : 'rtl'}>
        <Header context={context}
          posts={posts} language={language}
          changeLanguageHandler={(language) => {
            this.changeLanguageHandler(language)
          }} />
        <Switch>
          {/* start adp routes */}
          <Route
            path="/"
            exact
            render={() => <HomeMain calender={calender}
              posts={posts}
              homeAlbum={homeAlbum}
              latestProjects={latestProjects}
              lpObjs={lpObjs}
              latestEvents={latestEvents}
              latestProjects={latestProjects}
              homeImageDivider={homeImageDivider}
              context={context} footerText={footerText} />}
          />
          <Route
            path="/product"
            exact
            render={() => <PostsMain
              latestPosts={products} context={context} footerText={footerText}
              title={generalS.upcomingEvents[language]} />}
          />
          <Route
            path="/projects"
            exact
            render={() => <PostsMain latestPosts={latestProjects}
              context={context} footerText={footerText}
              title={generalS.latestProject[language]} />}
          />
          <Route
            path="/detail"
            render={() => <Detail context={context} posts={posts}
              allpost={allpost} footerText={footerText} />}
          />
          <Route
            path="/about"
            exact
            render={() => <AboutMain title={generalS.about[language]}
              footerText={footerText}
              addresses={addresses}
              teamMembersObj={teamMembersObj}
              teamMembers={teamMembers}
              aboutUs={aboutUs} context={context} posts={posts} />}
          />
          {authenticated ?
            <Route
              path="/post"
              exact
              render={() =>
                <PostMain context={context} posts={posts} footerText={footerText} />}
            />
            : (
              <Route
                path="/post" exact
                render={() =>
                  <HomeMain calender={calender}
                    footerText={footerText}
                    posts={posts}
                    homeAlbum={homeAlbum}
                    latestProjects={latestProjects}
                    lpObjs={lpObjs}
                    latestEvents={latestEvents}
                    homeImageDivider={homeImageDivider}
                    context={context} />}
              />
            )
          }
          {authenticated ?
            <Route
              path="/user"
              exact
              render={() => <UserMain context={context} posts={posts} />}
            />
            : (
              <Route
                path="/user" exact
                render={() =>
                  <HomeMain calender={calender}
                    posts={posts}
                    homeAlbum={homeAlbum}
                    latestProjects={latestProjects}
                    lpObjs={lpObjs}
                    latestEvents={latestEvents}
                    homeImageDivider={homeImageDivider}
                    context={context} />}
              />
            )
          }
          {authenticated ?
            <Route
              path="/settings"
              exact
              render={() => <SettingsMain context={context} posts={posts} />}
            />
            : (
              <Route
                path="/settings" exact
                render={() =>
                  <HomeMain calender={calender}
                    posts={posts}
                    homeAlbum={homeAlbum}
                    latestProjects={latestProjects}
                    lpObjs={lpObjs}
                    latestEvents={latestEvents}
                    homeImageDivider={homeImageDivider}
                    context={context} />}
              />
            )
          }
          <Route
            path="/madboyaadmin"
            exact
            render={() => <AdminPanel context={context} posts={posts} />}
          />
          <Route
            path="*"
            exact
            render={() => <PageNotFound context={context} />}
          />
        </Switch>
      </div>
    );
  }
}

export default Routes;
